export default "__VITE_ASSET__DKU6mqOI__"